"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeedbackReducer = void 0;
var react_1 = __importDefault(require("react"));
function reducer(state, action) {
    switch (action.type) {
        case 'click_thumbs_up':
            return __assign(__assign({}, state), { feedback: 'GOOD' });
        case 'click_thumbs_down':
            return __assign(__assign({}, state), { feedback: 'BAD' });
        case 'click_toxic':
            return __assign(__assign({}, state), { biasedToxicHarmful: !state.biasedToxicHarmful });
        case 'click_inaccurate':
            return __assign(__assign({}, state), { inaccurate: !state.inaccurate });
        case 'click_incomplete':
            return __assign(__assign({}, state), { incomplete: !state.incomplete });
        case 'click_inappropriate':
            return __assign(__assign({}, state), { inappropriate: !state.inappropriate });
        case 'click_other':
            return __assign(__assign({}, state), { other: !state.other });
        case 'text':
            return __assign(__assign({}, state), { feedbackText: action.feedbackText });
        case 'reset':
            return initial;
    }
}
var initial = {
    feedback: null,
    feedbackText: '',
    biasedToxicHarmful: false,
    inaccurate: false,
    incomplete: false,
    inappropriate: false,
    other: false,
};
function useFeedbackReducer() {
    return react_1.default.useReducer(reducer, initial);
}
exports.useFeedbackReducer = useFeedbackReducer;
//# sourceMappingURL=FeedbackReducer.js.map